<template>
    <div
        v-if="show"
        data-test-page-spinner-overlay
        class="splash grid-y align-center-middle"
        role="status"
        aria-live="polite"
        aria-busy="true"
        aria-label="Henter data"
    >
        <div>
            <div class="spinner" />
            <span class="sr-only">Henter...</span>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { find } from 'lodash';

export default {
    name: 'PageSpinner',
    props: {
        spinnerUrlList: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            show: false
        };
    },
    created() {
        const self = this;
        window.onbeforeunload = function () {
            if (document.activeElement.protocol !== 'tel:') {
                const url = document.activeElement.pathname;
                const fileTypeExists = typeof url != 'undefined' ? url.substring(url.lastIndexOf('/') + 1).split('.').length > 1 : false;
                self.show = !fileTypeExists;
            } else {
                document.activeElement.blur();
            }
        };
        // Add a request interceptor
        axios.interceptors.request.use((config) => {
            // Do something before request is sent
            if (self.spinnerUrlList.length > 0 && find(self.spinnerUrlList, (e) => e === config.url)) {
                self.show = true;
            }
            return config;
        }, (error) => {
            // Do something with request error
            self.show = false;
            return Promise.reject(error);
        });

        // Add a response interceptor
        axios.interceptors.response.use((response) => {
            // Do something with response data
            if (self.spinnerUrlList.length > 0 && find(self.spinnerUrlList, (e) => e === response.config.url)) {
                self.show = false;
            }
            return response;
        }, (error) => {
            // Do something with response error
            self.show = false;
            return Promise.reject(error);
        });
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    const overlay = this.$el;
                    if (overlay && typeof overlay.focus === 'function') {
                        overlay.setAttribute('tabindex', '-1');
                        overlay.focus();
                    }
                });
            }
        }
    },
};
</script>
<style lang="scss" scoped>
.splash {
    background-color: rgba(90,90,90,0.5);
    width: 100vw;
    height: 100vh;
    z-index: 10008;
    position: fixed;
    top: 0px;
    left: 0;
    
    &:focus {
        outline: none;
    }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  white-space: nowrap;
  border: 0;
  clip-path: inset(50%);
}
@media (prefers-reduced-motion: reduce) {
    .spinner {
        animation: none !important;
    }
}
</style>
